import { Icon } from "@/components/icon";
import type { NavProps } from "@/components/nav";

export const frontendNavData: NavProps["data"] = [
    {
        name: "sys.nav.dashboard",
        items: [
            {
                title: "sys.nav.dashboard", // 仪表盘
                path: "/dashboard",
                icon: <Icon icon="local:ic-workbench" size="24" />,
            },
            {
                title: "sys.nav.users", // 用户管理
                path: "/users",
                icon: <Icon icon="solar:users-group-rounded-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.orders", // 订单管理
                path: "/stripe/transactions",
                icon: <Icon icon="solar:cart-large-2-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.subscriptions", // 订阅管理
                path: "/subscriptions",
                icon: <Icon icon="solar:user-check-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.generations", // 生成记录
                path: "/generations",
                icon: <Icon icon="solar:document-add-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.writingDocuments", // Writing 文档
                path: "/writing/documents",
                icon: <Icon icon="solar:document-text-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.resource", // 资源管理
                path: "/resource",
                icon: <Icon icon="solar:server-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.checkin", // 签到管理
                path: "/checkin",
                icon: <Icon icon="solar:calendar-mark-bold-duotone" size="24" />,
            },
            // {
            // 	title: "sys.nav.logs",
            // 	path: "/logs/requests",
            // 	icon: <Icon icon="solar:document-text-bold-duotone" size="24" />,
            // },
            {
                title: "sys.nav.emailLogs",
                path: "/logs/emails",
                icon: <Icon icon="solar:mailbox-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.blog",
                path: "/blog",
                icon: <Icon icon="solar:document-text-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.activities",
                path: "/activities",
                icon: <Icon icon="solar:calendar-mark-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.activityLogs",
                path: "/activities/logs",
                icon: <Icon icon="solar:history-bold-duotone" size="24" />,
            },
            // Pricing management
            {
                title: "sys.nav.pricing",
                path: "/pricing",
                icon: <Icon icon="solar:wallet-bold-duotone" size="24" />,
            },
            {
                title: "sys.nav.sitemap",
                path: "/site/sitemap",
                icon: <Icon icon="solar:earth-bold-duotone" size="24" />,
            },
            // Changelog management
            {
                title: "sys.nav.changelog",
                path: "/changelog",
                icon: <Icon icon="mingcute:version-fill" size="24" />,
            },
            // Roulette logs management
            {
                title: "sys.nav.roulette_logs",
                path: "/roulette/logs",
                icon: <Icon icon="mingcute:celebrate-fill" size="24" />,
            },
            // Maintenance page management
            {
                title: "sys.nav.maintenance",
                path: "/maintenance",
                icon: <Icon icon="solar:settings-bold-duotone" size="24" />,
            },
            // Support tickets management
            {
                title: "sys.nav.support",
                path: "/support",
                icon: <Icon icon="solar:help-bold-duotone" size="24" />,
            },
        ],
    },
];
